
export default{
    name: "FAQCard",
    props: {
        FAQS: Array,
    },
}
